(function () {
  document.querySelectorAll('.livana-landing').forEach(function (root) {
    var dialog = root.querySelector('[data-lvl-nutrition-dialog]');
    var openers = root.querySelectorAll('[data-lvl-nutrition-open]');
    var closers = root.querySelectorAll('[data-lvl-nutrition-close]');
    var returnFocusTo = null;

    if (!dialog || !openers.length || typeof dialog.showModal !== 'function') return;

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () {
        returnFocusTo = opener;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('lvl-nutrition-open');
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('lvl-nutrition-open');
      if (returnFocusTo && returnFocusTo.isConnected) returnFocusTo.focus();
      returnFocusTo = null;
    });
  });
})();
